// Maps between the IDP admin OAuth client wire shapes and the feature domain
// types — the single boundary where the wire shape is known.
import type { AllowedScopesResponse } from '@/api/access.types'
import type {
  OAuthClientResponse,
  RegisterOAuthClientRequest,
  UpdateOAuthClientRequest,
} from '@/api/oauthClients.types'
import type { AllowedScope, OAuthClient, OAuthClientInput } from '../types'

export function toOAuthClient(response: OAuthClientResponse): OAuthClient {
  return {
    id: response.id,
    description: response.description,
    redirectURLs: response.redirectURLs,
    public: response.publicOne,
    secret: response.secret,
    forAccounts: response.isForAccounts,
    active: response.active,
  }
}

// Create path. moduleId is not modelled by the dashboard (db clients are not
// module-scoped here), so it is sent null.
export function toRegisterRequest(input: OAuthClientInput): RegisterOAuthClientRequest {
  return {
    description: input.description,
    redirectURLs: input.redirectURLs,
    publicOne: input.public,
    moduleId: null,
    isForAccounts: input.forAccounts,
  }
}

// Edit path: description + redirects + isForAccounts (public is fixed once set).
export function toUpdateRequest(input: OAuthClientInput): UpdateOAuthClientRequest {
  return {
    description: input.description,
    redirectURLs: input.redirectURLs,
    isForAccounts: input.forAccounts,
  }
}

export function toInput(client: OAuthClient): OAuthClientInput {
  return {
    description: client.description,
    redirectURLs: client.redirectURLs,
    public: client.public,
    forAccounts: client.forAccounts,
  }
}

export function toAllowedScopes(response: AllowedScopesResponse): AllowedScope[] {
  return response.scopes.map((scope) => ({ id: scope.id, value: scope.value }))
}
